import { render, staticRenderFns } from "./SummaryInfoTab.vue?vue&type=template&id=231788a9&scoped=true&"
import script from "./SummaryInfoTab.vue?vue&type=script&lang=js&"
export * from "./SummaryInfoTab.vue?vue&type=script&lang=js&"
import style0 from "./SummaryInfoTab.vue?vue&type=style&index=0&id=231788a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231788a9",
  null
  
)

export default component.exports